export interface Address {
    streetName: string,
    streetNumber: string,
    houseNumber: string,
    city: string,
    zipCode: string,
    voivodeship: string,
    municipality: string, // gmina
    district: string, //powiat
    municipalityCode: string,
}

export interface Employee {
    name: string,
    surname: string,
    pesel: string,
    birthDate: string,
    sex: string,
    phoneNumber: string,
    email: string,
    education: string,
    address: Address,
    employedSince: string,
    employedUntil: string,
    employedIndefinitely: boolean,
    shiftCount: number,
    activeForCoaching: boolean,
}

export interface Financials {
    companySize: string,
    netProfit: number,
    ebit: number,
    netRevenue: number,
    tax: number,
    positionsCount: number,
    employeesCount: number,
    managementPositions: number,
}

export interface Customer {
    nip: string,
    regon: string,
    pkd: string,

    name: string,
    surname: string,
    education: string,
    pesel: string,
    birthDate: string,
    sex: string,
    disability: string,
    phoneNumber: string,
    email: string,
    address: Address,

    companyOwnerName: string,
    companyOwnerSurname: string,
    companyAddress: Address,
    companyName: string,
    companyCreationDate: string,
    companyStartDate: string,
    accountNumber: string,
    bankName: string,

    login: string,
    password: string,
    autodiagnosisCode: string,

    deMinimisPLN: number,
    deMinimisEUR: number,
    usesDeMinimis: boolean,

    financials0: Financials,
    financials1: Financials,
    financials2: Financials,

    employees: Employee[],

    dataComplete: boolean,
    qualified: boolean,

    createdAt: number,
    createdBy: string,

    notes: string

    settlement: string

    isDisabled: boolean
}

export function emptyCustomer(): Customer {
    return {
        nip: '',
        regon: '',
        pkd: '',

        name: '',
        surname: '',
        education: '',
        pesel: '',
        birthDate: '2022-01-01',
        sex: '',
        disability: '',
        phoneNumber: '',
        email: '',
        address: {
            streetName: '',
            streetNumber: '',
            houseNumber: '',
            city: '',
            zipCode: '',
            voivodeship: '',
            municipality: '',
            district: '',
            municipalityCode: '',
        },
        companyOwnerName: '',
        companyOwnerSurname: '',
        companyAddress: {
            streetName: '',
            streetNumber: '',
            houseNumber: '',
            city: '',
            zipCode: '',
            voivodeship: '',
            district: '',
            municipality: '',
            municipalityCode: '',
        },
        companyName: '',
        companyCreationDate: '2022-01-01',
        companyStartDate: '2022-01-01',
        accountNumber: '',
        bankName: '',
        login: '',
        password: '',
        autodiagnosisCode: '',
        deMinimisPLN: 0,
        deMinimisEUR: 0,
        usesDeMinimis: false,
        financials0: {
            companySize: '',
            tax: 0,
            netProfit: 0,
            ebit: 0,
            netRevenue: 0,
            positionsCount: 0,
            employeesCount: 0,
            managementPositions: 0,
        },
        financials1: {
            companySize: '',
            tax: 0,
            netProfit: 0,
            ebit: 0,
            netRevenue: 0,
            positionsCount: 0,
            employeesCount: 0,
            managementPositions: 0,
        },
        financials2: {
            companySize: '',
            tax: 0,
            netProfit: 0,
            ebit: 0,
            netRevenue: 0,
            positionsCount: 0,
            employeesCount: 0,
            managementPositions: 0,
        },
        employees: [],
        dataComplete: false,
        qualified: false,
        createdAt: 0,
        createdBy: '',
        notes: '',
        settlement: '',
        isDisabled: false
    }
}